import PartnersList from '@/features/partners/PartnersList.tsx';

export default function PsiPartnersPage() {
  return <PartnersList />;
}
